/*
 * @Description  : aegis 相关常量
 * @usage        :
 * @FilePath: /app-monorepo-projects/packages/app-share/src/constants/aegis.ts
 */

// aegis 日志类型
export enum EAegisLogTypes {
  LOG = 'log',  // 日志
  SPEED = 'speed', // 接口和静态资源测速
  PERFORMANCE = 'performance', // 页面测速
  OFFLINE = 'offline', // 离线日志上传
  WHITE_LIST = 'whiteList', // 白名单
  VITALS = 'vitals', // vitals
  PV = 'pv', // pv
  CUSTOM_PV = 'customPV', // 自定义pv
  EVENT = 'event', // 自定义事件
  CUSTOM = 'custom', // 自定义测速
  SDK_ERROR = 'sdkError', // sdk报错
  SET_DATA = 'setData', // 小程序 set data
}

// aegis 日志等级
export enum EAegisLogLevelTypes {
  // 接口请求日志（白名单日志）
  whiteListLog = '1',
  // 一般日志
  normal = '2',
  // js 执行错误
  jsExcutionError = '4',
  // promise 错误
  promiseError = '8',
  // ajax 请求异常
  ajaxError = '16',
  // js 加载异常
  jsLoadError = '32',
  // 图片加载异常
  imgLoadError = '64',
  // css 加载异常
  cssLoadError = '128',
  // console.error(未启用)
  consoleError = '256',
  // 音视频资源异常
  mediaError = '512',
  // retcode 异常
  retcode = '1024',
  // aegis report
  aegisReport = '2048',
}

// 自定义测速的 log 结构
export interface AegisCustomTypeLogs {
  name: string;
  duration: number;
  ext1: string;
  ext2: string;
  ext3: string;
  from: string;
}

// 自定义事件的 log 结构
export interface AegisEventTypeLogs {
  name: string;
  ext1: string;
  ext2: string;
  ext3: string;
}

// 日志的 log 结构
export interface AegisLogypeLogs {
  level: EAegisLogLevelTypes;
  msg: string;
}

// 页面测速的 log 结构
export interface AegisPerformanceTypeLogs {
  contentDownload: number;
  dnsLookup: number;
  firstScreenTiming: number;
  resourceDownload: number;
  ssl: number;
  tcp: number;
  ttfb: number;
}

// 接口和静态资源测速的 log 结构
export interface AegisSpeedTypeLogs {
  connectTime: number;
  domainLookup: number;
  duration: number;
  isHttps: boolean;
  method: string;
  status: number;
  type: string;
  url: string;
  urlQuery: string;
}


// web vitals 的 log 结构
export interface AegisVitalsTypeLogs {
  duration: number;
  entries: PerformancePaintTiming[];
  id: string;
  name: string;
  value: number;
}

export type AegisVariantLogsTypes = AegisCustomTypeLogs
| AegisEventTypeLogs
| AegisLogypeLogs
| AegisPerformanceTypeLogs
| AegisSpeedTypeLogs
| AegisVitalsTypeLogs;
